// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"12fbcc3c","453":"0f5d9a6a","455":"35cd20a0"}[chunkId] + ".chunk.js";
};